import { memo } from 'react';
import { Paper, Stack, IconButton, Button } from '@mui/material';
import DialogTextField from 'components/dialog/DialogTextField';
import { ISurveyTypeProps } from 'interface/project/projectInfo';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import useProjectInfoProvider from 'hooks/useProjectInfoProvider';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useAppDispatch } from 'store';
import { showMessage } from 'store/message/messageSlice';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

function SurveyMC({ type, sort, component, handleRemove }: ISurveyTypeProps): JSX.Element {
  const dispatchApp = useAppDispatch();
  const { inputs, dcInputs, dispatch } = useProjectInfoProvider();
  const conditionInputs = type === 'inputs' ? inputs : dcInputs;
  const { stepper3 } = conditionInputs;
  const { questions } = stepper3;

  const handleQuestionChange = (value: string) => {
    dispatch({
      type: 'handleQuestion',
      payload: {
        type,
        questionId: component.questionId,
        question: value,
        actionType: 'update',
      },
    });
  };

  const handleItemChange = (contentId: string, value: string) => {
    dispatch({
      type: 'handleQuestion',
      payload: {
        type,
        questionId: component.questionId,
        contentId,
        content: value,
        actionType: 'updateItem',
      },
    });
  };

  const handleAddItem = () => {
    dispatch({
      type: 'handleQuestion',
      payload: {
        type,
        questionId: component.questionId,
        content: '',
        actionType: 'addItem',
      },
    });
  };
  const handleRemoveItem = (contentId: string) => {
    if (component.questionType === 'MC' && component.items.length === 1) {
      dispatchApp(
        showMessage({ message: '체크박스 유형은 최소 1개 이상의 선택지가 존재해야 합니다.', variant: 'warning' }),
      );
      return;
    }
    dispatch({
      type: 'handleQuestion',
      payload: {
        type,
        questionId: component.questionId,
        contentId,
        actionType: 'deleteItem',
      },
    });
  };

  return (
    <Paper elevation={5} sx={{ p: 2, m: 2, display: 'flex', justifyContent: 'flex-start' }}>
      <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
        <DialogTextField
          label={`Q${sort + 1}`}
          labelWidth={40}
          text={questions[sort]?.question || ''}
          variant="outlined"
          name="content"
          onChange={e => handleQuestionChange(e.target.value)}
        />
        {component.items.map(item => (
          <Stack direction="row" alignItems="center" key={item.contentId} spacing={2} justifyContent="flex-start">
            <DialogTextField
              label={<CheckBoxOutlineBlankIcon sx={{ width: 16, color: 'mind.custom.checkBorder' }} />}
              labelWidth={40}
              labelSx={{ textAlign: 'right' }}
              text={item.content}
              onChange={e => handleItemChange(item.contentId, e.target.value)}
              variant="outlined"
              fullWidth
              stackSx={{ display: 'flex', width: '70%' }}
            />
            <IconButton onClick={() => handleRemoveItem(item.contentId)} sx={{ color: 'error.main' }}>
              <RemoveCircleOutlineIcon />
            </IconButton>
          </Stack>
        ))}
        <Button
          variant="outlined"
          startIcon={<AddCircleOutlineIcon />}
          sx={{ minWidth: '120px', width: '120px', marginLeft: '48px!important' }}
          onClick={handleAddItem}
        >
          선택지 추가
        </Button>
        <Stack direction="row" justifyContent="flex-end">
          <IconButton onClick={() => handleRemove(component.questionId || '')} sx={{ color: 'error.main', width: 32 }}>
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Stack>
      </Stack>
    </Paper>
  );
}

export default memo(SurveyMC);
